export default {
  emailjs: {
    serviceId: "service_def8ewj",
    templateId: "template_ev8ppjn",
    publicKey: "8xBAugXy-QzYp_46H",
  },
};
